<template>
    <section class="scene" id="wrapperTitle">
        <div class="static-container">
            <h1 class="title">
                &lt;/wrapper&gt;
            </h1>
            <div class="std">
                <p class="-gray">
                    /*<br>
                </p>
                <span class="progress_bar_skill">Python <i class="val">90%</i></span>
                <div class="progress_bar">
                    <span id="python_progress" percentage="90"></span>
                </div>
                <br>
                <span class="progress_bar_skill">Javascript <i class="val">80%</i></span>
                <div class="progress_bar">
                    <span id="js_progress" percentage="80"></span>
                </div>
                <br>
                <span class="progress_bar_skill">Linux <i class="val">95%</i></span>
                <div class="progress_bar">
                    <span id="linux_progress" percentage="95"></span>
                </div>
                <p class="-gray">
                    <br>*/
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Wrapper'
    }
</script>